import mustache from 'mustache'

const commandSeparator = ':'

export function buildFiltersFromContext(fieldCtx, ctx) {
    let filters = {
        filterOn: [],
        filter: ''
    }

    if (!fieldCtx) return filters;

    fieldCtx.forEach(c => {
        let key = c.key.split(commandSeparator)

        if (key[0] == "filter") {
            filters.filterOn.push(key[1])

            // render value
            filters.filter += mustache.render(c.value, ctx.model)
        }
    })

    return filters;
}